import { useState, useEffect } from 'react';
import { breakpoints } from '../styles/media-queries';

enum SCREENS {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile'
}

export function useWindowSize() {
  const [screenType, setScreenType] = useState(SCREENS.DESKTOP);

  useEffect(() => {
    function handleResize() {
      const windowSizeWidth = window.innerWidth;
      if (windowSizeWidth >= breakpoints.desktop) {
        setScreenType(SCREENS.DESKTOP);
      } else if (
        windowSizeWidth >= breakpoints.tablet &&
        windowSizeWidth < breakpoints.desktop
      ) {
        setScreenType(SCREENS.TABLET);
      } else {
        setScreenType(SCREENS.MOBILE);
      }
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenType;
}
